import { request } from '../auth/client';
import type {
  PlatformAdminKeyTestResponse,
  PlatformSettings,
  SetOpenAIAdminKeyInput,
} from '@runik/shared';

export const platformSettingsKey = ['platform-settings'] as const;

export function getPlatformSettings() {
  return request<PlatformSettings>('/api/platform/settings');
}

export function setOpenAIAdminKey(body: SetOpenAIAdminKeyInput) {
  return request<{ ok: boolean; rotated: boolean }>('/api/platform/settings/openai', {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function testOpenAIAdminKey() {
  return request<PlatformAdminKeyTestResponse>('/api/platform/settings/openai/test', {
    method: 'POST',
  });
}

export function clearOpenAIAdminKey() {
  return request<void>('/api/platform/settings/openai', { method: 'DELETE' });
}
